<div class="recipient-info">
  <form [formGroup]="form" class="recipient-info__form scrollable">
    <div class="recipient-info__inputs-wrapper">
      <div class="recipient-info__inputs-group">
        <div class="recipient-info__input-wrapper recipient-info__input-wrapper_phone">
          <span class="recipient-info__input-text">Fax Number *:</span>

          <input
            formControlName="toNumberCode" aria-required="true"
            class="form-input_md recipient-input recipient-input_phonecode autocomplete"
            (keypress)="leaveNumbersAndPlusChars($event)"
          />

          <input
            formControlName="toNumber" aria-required="true"
            type="text"
            inputmode="numeric"
            class="form-input_md recipient-input recipient-input_phone autocomplete"
            (keypress)="leaveNumbersChars($event)"
          />

          <div class="recipient-info__buttons-wrapper">
            <button type="button" class="recipient-info__button" (click)="openSelectContactModal()">
              <img
                src="assets/img/keylock-plus.svg"
                alt="Open contact selection modal"
                class="recipient-info__img"
              />
            </button>

            <button type="button" class="recipient-info__button" (click)="clearNumberAndDeliverToFields()">
              <img
                src="assets/img/stop.svg"
                alt="Clear 'To Number' and 'Deliver To' fields"
                class="recipient-info__img"
              />
            </button>
          </div>
        </div>

        <div class="recipient-info__input-wrapper">
          <span class="recipient-info__input-text">Deliver To *:</span>
          <input formControlName="deliveryTo" aria-required="true" class="form-input_md recipient-input recipient-input_default" />
        </div>

        <div class="recipient-info__input-wrapper">
          <span class="recipient-info__input-text">Fax Subject *:</span>
          <input
            formControlName="faxSubject"
            class="form-input_md recipient-input recipient-input_default"
            aria-required="true"
          />
        </div>
      </div>

      <div class="recipient-info__inputs-group">
        <div class="recipient-info__input-wrapper">
          <span class="recipient-info__input-text">From Number *:</span>
          <div class="recipient-select-wrapper">
            <select formControlName="fromNumber" aria-required="true" class="recipient-select">
              <option *ngFor="let clientNumber of clientNumbers" [value]="clientNumber.number">
                {{ clientNumber.number }}
              </option>
            </select>

            <img src="assets/img/triangle.svg" alt="" class="recipient-select-triangle" />
          </div>
        </div>

        <div class="recipient-info__input-wrapper">
          <span class="recipient-info__input-text">Sent From *:</span>
          <input formControlName="sentFrom" aria-required="true" class="form-input_md recipient-input recipient-input_default" />
        </div>

        <div class="recipient-info__input-wrapper">
          <span class="recipient-info__input-text">Cover page:</span>
          <div class="recipient-select-wrapper">
            <select formControlName="coverPage" class="recipient-select">
              <option value="none">None</option>
              <option value="add">Add cover page</option>
              <option *ngFor="let coverPage of coverPages" [value]="coverPage.title">
                {{ coverPage.title }}
              </option>
            </select>

            <img src="assets/img/triangle.svg" alt="" class="recipient-select-triangle" />
          </div>
        </div>
      </div>
    </div>

    <div class="recipient-info__input-wrapper recipient-info__input-wrapper_textarea">
      <span class="recipient-info__input-text recipient-info__input-text_textarea">Notes:</span>
      <div class="recipient-info__textarea-wrapper">
        <textarea formControlName="notes" class="form-input_md recipient-info__textarea"></textarea>
        <p class="recipient-info__textarea-length">{{ notesLength }} / 120</p>
      </div>
    </div>
  </form>

  <div class="send-page__actions">
    <button [disabled]="form.invalid" class="btn_primary btn_md" (click)="onSubmit()">Next</button>
  </div>
</div>

<app-select-contact-modal (select)="selectContact($event)"></app-select-contact-modal>

<app-create-cover-page-modal
  [clientNumbers]="clientNumbers"
  (submit)="createCoverPage($event)"
></app-create-cover-page-modal>
